import { putQueryParam, toUrlT, URLParser } from '@execonline-inc/url';
import { Task } from 'taskarian';
import { callApi } from '../../../Appy';
import { currentUserStore } from '../../../CurrentUserStore';
import { groupResourcesDecoder } from '../../../GroupsStore/Decoders';
import { findLinkT } from '../../../LinkyLinky';
import { participantsResourceDecoder } from '../../../ParticipantsStore/Decoders';
import { Link } from '../../../Resource/Types';
import { defaultOrgFilter } from '../../Form/OrganizationFilterDynamicTypeaheadSelect/Filters/Organization';
import { CountError } from './Types';

const withUrl =
  (update: (url: URLParser) => URLParser) =>
  (link: Link): Task<CountError, Link> =>
    toUrlT(link.href)
      .map(update)
      .map((url): Link => ({ ...link, href: url.href }));

const currentUserLink = (rel: 'participants' | 'user-groups'): Task<CountError, Link> =>
  Task.succeed<CountError, ReadonlyArray<Link>>(currentUserStore.links).andThen(findLinkT(rel));

/**
 * Same request the participants table makes with no query, at one row per
 * page: only the total is needed.
 */
export const countParticipants = (): Task<CountError, number> =>
  currentUserLink('participants')
    .andThen(withUrl((url) => putQueryParam('per_page', '1', putQueryParam('page', '1', url))))
    .andThen(callApi(participantsResourceDecoder, {}))
    .map((resource) => resource.metadata.resultsCount);

/**
 * Same request the Groups list makes on load (including its default
 * organization filter for ExecOnline admins), so the two totals agree.
 */
export const countGroups = (): Task<CountError, number> =>
  currentUserLink('user-groups')
    .andThen(
      withUrl((url) =>
        defaultOrgFilter().searchParameters.reduce(
          (acc, parameter) =>
            putQueryParam(`user_groups_filter[${parameter.key}]`, parameter.value, acc),
          putQueryParam('page', '1', url),
        ),
      ),
    )
    .andThen(callApi(groupResourcesDecoder, {}))
    .map((resource) => resource.metadata.resultsCount);
